var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('span',{class:[_vm.type, { small: _vm.small, 'font-weight-bold': _vm.strong }]},[_vm._v(_vm._s(_vm.$t("availability." + _vm.type)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }